import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import GallerySection from '../components/GallerySection';
import ContactForm from '../components/ContactForm';

export default function CommercialCleaning() {
  const officeImg = 'https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/3c7718da-c622-4e09-b9ce-f749a5967f74/commercial-office-cleaning.png';

  return (
    <div>
      <SEO
        title="Erhvervsrengøring - Power-Multiservice"
        description="Stabil og professionel erhvervsrengøring af kontorer, klinikker og butikker. Skræddersyede rengøringsaftaler for virksomheder."
        path="/erhvervsrengoering"
      />

      {/* HERO SECTION */}
      <section className="bg-emerald-950 text-white py-16 sm:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
            
            <div className="lg:col-span-7 space-y-6 text-center lg:text-left animate-fade-in-up">
              <h1 className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-white leading-tight">
                Pålidelig rengøringsservice til din virksomhed
              </h1>

              <p className="text-base sm:text-lg text-slate-300 leading-relaxed max-w-2xl mx-auto lg:mx-0">
                Et sundt indeklima og præsentable rammer styrker både arbejdsglæden og det professionelle indtryk over for dine kunder. Vi leverer stabil erhvervsrengøring med faste rutiner og høj fleksibilitet.
              </p>

              <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-center lg:justify-start gap-3 sm:gap-4 pt-2">
                <a
                  href="#tilbud-formular"
                  className="group px-7 py-3.5 rounded-full font-bold text-sm sm:text-base text-slate-950 bg-emerald-400 hover:bg-emerald-300 hover:scale-[1.02] active:scale-[0.98] transition-all duration-200 flex items-center justify-center gap-2"
                >
                  <span>Indhent erhvervstilbud</span>
                  <i className="fa-solid fa-arrow-down text-xs group-hover:translate-y-0.5 transition-transform duration-200" aria-hidden="true" />
                </a>

                <Link
                  to="/prisberegner"
                  className="group px-6 py-3.5 rounded-full font-bold text-sm sm:text-base text-white bg-transparent hover:bg-white/10 border border-white hover:scale-[1.02] active:scale-[0.98] transition-all duration-200 flex items-center justify-center gap-2"
                >
                  <i className="fa-solid fa-calculator text-white text-sm group-hover:rotate-12 transition-transform duration-300" aria-hidden="true" />
                  <span>Beregn vejledende pris</span>
                </Link>
              </div>
            </div>

            <div className="lg:col-span-5 animate-fade-in-up delay-100">
              <div className="group overflow-hidden">
                <img
                  src={officeImg}
                  alt="Moderne erhvervskontor i Danmark"
                  className="w-full h-80 sm:h-96 object-cover group-hover:scale-105 transition-transform duration-700 ease-out"
                />
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* VÆRDIER & FORDELE FOR VIRKSOMHEDER */}
      <section className="py-16 sm:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          
          <div className="text-center max-w-3xl mx-auto mb-12">
            <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-900 tracking-tight">
              Hvorfor vælge Power-Multiservice til erhverv?
            </h2>
            <p className="mt-3 text-slate-600 text-base">
              Vi forstår vigtigheden af stabilitet, diskretion og ensartet høj kvalitet.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            
            <div className="p-6 sm:p-8 bg-slate-50 border border-slate-200/80">
              <div className="text-black text-3xl mb-4">
                <i className="fa-solid fa-clock-rotate-left" aria-hidden="true" />
              </div>
              <h3 className="text-lg font-bold text-slate-900 mb-2">Høj stabilitet & faste rutiner</h3>
              <p className="text-slate-600 text-sm leading-relaxed">
                Rengøringen udføres til de aftalte tider uden forstyrrelser af jeres daglige drift og med faste arbejdsgange.
              </p>
            </div>

            <div className="p-6 sm:p-8 bg-slate-50 border border-slate-200/80">
              <div className="text-black text-3xl mb-4">
                <i className="fa-solid fa-handshake" aria-hidden="true" />
              </div>
              <h3 className="text-lg font-bold text-slate-900 mb-2">Individuelle aftaler</h3>
              <p className="text-slate-600 text-sm leading-relaxed">
                Hver virksomhed er unik. Vi skræddersyr omfang, frekvens og rengøringsplan til jeres konkrete kvadratmeter og faciliteter.
              </p>
            </div>

            <div className="p-6 sm:p-8 bg-slate-50 border border-slate-200/80">
              <div className="text-black text-3xl mb-4">
                <i className="fa-solid fa-shield-check" aria-hidden="true" />
              </div>
              <h3 className="text-lg font-bold text-slate-900 mb-2">Professionelt udtryk</h3>
              <p className="text-slate-600 text-sm leading-relaxed">
                Rene skriveborde, velduftende toiletter og skinnende mødelokaler, der giver det rette indtryk over for kunder.
              </p>
            </div>

            <div className="p-6 sm:p-8 bg-slate-50 border border-slate-200/80">
              <div className="text-black text-3xl mb-4">
                <i className="fa-solid fa-comment-dots" aria-hidden="true" />
              </div>
              <h3 className="text-lg font-bold text-slate-900 mb-2">Effektiv kommunikation</h3>
              <p className="text-slate-600 text-sm leading-relaxed">
                Direkte kontaktperson og hurtig respons, hvis der opstår ad hoc opgaver, arrangementer eller ændringer.
              </p>
            </div>

            <div className="p-6 sm:p-8 bg-slate-50 border border-slate-200/80">
              <div className="text-black text-3xl mb-4">
                <i className="fa-solid fa-leaf" aria-hidden="true" />
              </div>
              <h3 className="text-lg font-bold text-slate-900 mb-2">Sundt indeklima</h3>
              <p className="text-slate-600 text-sm leading-relaxed">
                Vi fjerner støv og bakterier med gode rengøringsmidler, hvilket gavner medarbejdernes velvære.
              </p>
            </div>

            <div className="p-6 sm:p-8 bg-slate-50 border border-slate-200/80">
              <div className="text-black text-3xl mb-4">
                <i className="fa-solid fa-circle-check" aria-hidden="true" />
              </div>
              <h3 className="text-lg font-bold text-slate-900 mb-2">Fleksible intervaller</h3>
              <p className="text-slate-600 text-sm leading-relaxed">
                Mulighed for daglig rengøring, flere gange om ugen eller faste ugentlige besøg efter ønske.
              </p>
            </div>

          </div>
        </div>
      </section>

      {/* DYNAMISK CMS GALLERI FOR ERHVERVSRENGØRING */}
      <GallerySection
        slug="erhvervsrengoering"
        title="Erhvervsgalleri"
        subtitle="Referencer og erhvervsmiljøer"
      />

      {/* KONTAKTFORMULAR SEKTION MED KONTAKTOPLYSNINGER I VENSTRE SIDE */}
      <section id="tilbud-formular" className="py-16 sm:py-20 bg-slate-50 border-t border-slate-200/80">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-start">
            
            {/* Kontaktoplysninger i venstre side */}
            <div className="lg:col-span-5 space-y-6 text-left">
              <div>
                <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-900 tracking-tight">
                  Direkte kontakt for erhverv
                </h2>
                <p className="text-slate-600 text-sm sm:text-base mt-2 leading-relaxed">
                  Har du spørgsmål til en erhvervsaftale, eller ønsker du en uforpligtende besigtigelse af jeres lokaler? Kontakt os direkte eller udfyld formularen.
                </p>
              </div>

              <div className="space-y-4 pt-2">
                <a
                  href="tel:31686764"
                  className="flex items-center gap-4 text-slate-900 hover:text-emerald-700 transition-colors group"
                >
                  <i className="fa-solid fa-phone text-black text-lg" aria-hidden="true" />
                  <div className="text-base font-bold whitespace-nowrap">31 68 67 64</div>
                </a>

                <a
                  href="mailto:zokimaretic@gmail.com"
                  className="flex items-center gap-4 text-slate-900 hover:text-emerald-700 transition-colors group"
                >
                  <i className="fa-solid fa-envelope text-black text-lg" aria-hidden="true" />
                  <div className="text-base font-bold whitespace-nowrap">zokimaretic@gmail.com</div>
                </a>

                <div className="flex items-center gap-4 text-slate-900">
                  <i className="fa-solid fa-location-dot text-black text-lg" aria-hidden="true" />
                  <div className="text-base font-bold">Idrætsvej 1, 5580 Nørre Aaby</div>
                </div>

                <div className="flex items-center gap-4 text-slate-900">
                  <i className="fa-solid fa-building text-black text-lg" aria-hidden="true" />
                  <div className="text-base font-bold">Power-Multiservice (CVR: 27253466)</div>
                </div>
              </div>

              <div className="pt-4 border-t border-slate-200">
                <ul className="space-y-2 text-sm text-slate-700">
                  <li className="flex items-center gap-2">
                    <i className="fa-solid fa-check text-black" aria-hidden="true" />
                    <span>Uforpligtende besigtigelse og dialog</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="fa-solid fa-check text-black" aria-hidden="true" />
                    <span>Hurtig tilbagemelding inden for 24 timer</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="fa-solid fa-check text-black" aria-hidden="true" />
                    <span>Skræddersyet tilbud uden binding</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Formular i højre side */}
            <div className="lg:col-span-7">
              <ContactForm
                heading="Få et skræddersyet tilbud på erhvervsrengøring"
                initialData={{ serviceType: 'erhverv' }}
              />
            </div>

          </div>
        </div>
      </section>

    </div>
  );
}
